module.exports = __webpack_public_path__ + "img/title-bg.37e7eda7.png";